"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderList = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../../context");

var _utils = require("../../utils");

var _core = require("@emotion/core");

var _excluded = ["items"];
var Ul = (0, _context.styledWithTheme)('ul')(function (_ref) {
  var theme = _ref.theme;
  return {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    gap: theme.selectors.space('S200')
  };
});
var Li = (0, _context.styledWithTheme)('li')({
  display: 'flex'
});

var PageHeaderListWithoutDocs = function PageHeaderListWithoutDocs(_ref2) {
  var _ref2$items = _ref2.items,
      items = _ref2$items === void 0 ? [] : _ref2$items,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return (0, _core.jsx)(Ul, (0, _extends2.default)({
    role: "list"
  }, (0, _utils.pickDataProps)(forwardedProps)), items.map(function (item, index) {
    return (0, _core.jsx)(Li, {
      key: index
    }, item);
  }));
};

var PageHeaderListWithDocs = (0, _stencilReactDesc.describe)(PageHeaderListWithoutDocs).description('List element containing page header contents and placing them semantically in a list.');
PageHeaderListWithDocs.propTypes = {
  children: _stencilReactDesc.PropTypes.node.description('Content of the list.')
};
var PageHeaderList = (0, _utils.withTestAttributes)({
  component: 'StencilPageHeaderList'
})(PageHeaderListWithDocs);
exports.PageHeaderList = PageHeaderList;
PageHeaderList.displayName = 'PageHeaderList';